import React from "react";
import { motion } from "framer-motion";

import { ReactionIcon } from "./ReactionIcon";

import "./Reaction.scss";

export const ANIMATION_CONFIG = {
  visible: {
    opacity: 1,
    y: 0,
    transformOrigin: "50%",
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.04,
    },
  },

  hidden: {
    opacity: 0,
    y: 20,
    transformOrigin: "50%",
    transition: { delay: 0.2, duration: 0 },
  },

  closed: {
    opacity: 0,
    y: 0,
    transformOrigin: "50%",
    transition: { delay: 0, duration: 0 },
  },
};

export const ReactionsWrapper = ({ animate, setLike }) => {
  return (
    <motion.div
      initial="hidden"
      animate={animate}
      variants={ANIMATION_CONFIG}
      className="reactions-wrapper"
    >
      <ReactionIcon icon={`${process.env.PUBLIC_URL}/assets/icons/like.svg`} name="like" setLike={setLike} />
      <ReactionIcon icon={`${process.env.PUBLIC_URL}/assets/icons/love.svg`} name="love" setLike={setLike} />
      <ReactionIcon icon={`${process.env.PUBLIC_URL}/assets/icons/haha.svg`} name="haha" setLike={setLike} />
      <ReactionIcon icon={`${process.env.PUBLIC_URL}/assets/icons/wow.svg`} name="wow" setLike={setLike} />
    </motion.div>
  );
};
